enum NavigationOptions {
	BACK = 'back',
	NEXT = 'next'
}

export { NavigationOptions };
